import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locales from '../locales/locales'
Vue.use(VueI18n)

// 需要全局更改
let preferredLanguage = localStorage.getItem('locale') || 'zh-CN' // 语言标识

const i18n = new VueI18n({
  locale: preferredLanguage,
  fallbackLocale: preferredLanguage,
  messages: locales
})

export { i18n as default }
